export default __webpack_public_path__ + "static/media/AE1.d43eb201.webp";